import { render, staticRenderFns } from "./SearchContainer.vue?vue&type=template&id=844cb158&scoped=true&"
import script from "./SearchContainer.vue?vue&type=script&lang=js&"
export * from "./SearchContainer.vue?vue&type=script&lang=js&"
import style0 from "./SearchContainer.vue?vue&type=style&index=0&id=844cb158&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "844cb158",
  null
  
)

export default component.exports